'use client';

import { useEffect, useState } from 'react';
import { isValidLocale, DEFAULT_LOCALE } from '@/shared/constants/locales';

/**
 * Client-side locale detection hook
 * Detects user's preferred locale from browser language
 */
export function useDetectedLocale(): string | null {
  const [detectedLocale, setDetectedLocale] = useState<string | null>(null);

  useEffect(() => {
    // Only detect on first render
    if (typeof window === 'undefined') {
      return;
    }

    // Check browser language
    const browserLanguages = navigator.languages || [navigator.language];
    for (const lang of browserLanguages) {
      const locale = lang?.split('-')[0]; // Get just the language code
      if (locale && isValidLocale(locale) && locale !== DEFAULT_LOCALE) {
        setDetectedLocale(locale);
        return;
      }
    }
  }, []);

  return detectedLocale;
}
